import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import MonitorMap from './MonitorMap';
import MonitorTable from './MonitorTable';
import { useSelector } from 'react-redux';
import { getMonitorPage, getMonitorShowSelected } from '../../reducer/monitorPageSlice';
import MonitorTimeline from './MonitorTimeline';

const labelSummary = [
    {
        label: 'เข้าเกณฑ์เปิด EOC',
        color: 'rgb(63, 113, 179)',
        attrValue: 'eocqualify'
    },{
        label: 'เปิด EOC',
        color: 'rgb(212, 135, 108)',
        attrValue: 'eocactive'
    },{
        label: 'ไม่เปิด EOC',
        color: '#218416',
        attrValue: 'eocunactive'
    }
]

function Monitor() {
    // const [pageSelected, setPageSelected] = useState("map");
    const pageSelected = useSelector(getMonitorPage);
    // const [monitorSelected, setMonitorSelected] = useState({
    //     eocactive: true,
    //     eocqualify: true,
    //     eocunactive: true
    // })
    const monitorSelected = useSelector(getMonitorShowSelected);
    const [valueSummary, setValueSummary] = useState({
        eocactive: 0,
        eocqualify: 0,
        eocunactive: 0
    })

    // const { eocactive, eocqualify, eocunactive } = monitorSelected;

    // const pageChanged = (event, newValue) => {
    //     setPageSelected(newValue);
    //     // dispatch(setAreaLevel(newValue));
    // }

    // const monitorSelectedChange = (event) => {
    //     setMonitorSelected({
    //         ...monitorSelected,
    //         [event.target.name]: event.target.checked,
    //     });
    // };

    return (
        <div className="h-[calc(100vh-60px)] w-full">
            <TabContext value={pageSelected}>
                {/* <Grid container sx={{
                    backgroundColor: 'rgb(237, 237, 237)',
                    height: '50px'
                }}> */}
                    {/* <Grid item xl={6} lg={6} md={6} sx={{
                        
                    }}>
                        <Tabs
                            value={pageSelected}
                            variant='fullWidth'
                            onChange={pageChanged}
                            sx={{
                                marginLeft: '10px',
                                marginRight: '10px',
                                marginTop: '8px',
                                minHeight: '34px',
                                height: '34px',
                                backgroundColor: 'rgba(0, 0, 0, 0.23)',
                                borderRadius: '4px',
                                '& .MuiTabs-indicator': {
                                    backgroundColor: 'rgb(212, 135, 108)',
                                    zIndex: 1,
                                    height: '100%'
                                }
                            }}
                        >
                            <StyledTab label="แผนที่" value="map" />
                            <StyledTab label="ตาราง" value="table" />
                            <StyledTab label="ไทม์ไลน์" value="timeline" />
                        </Tabs>
                    </Grid> */}
                    {/* <Grid item xl={4.5} lg={4} md={4}>
                        <FormControl sx={{ mt: '5px' }} component="fieldset" variant="standard">
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Checkbox 
                                            checked={eocactive} 
                                            onChange={monitorSelectedChange} 
                                            name="eocactive"
                                            sx={{
                                                color: 'rgba(0, 0, 0, 0.6)',
                                                '&.Mui-checked': {
                                                    color: 'rgb(212, 135, 108)',
                                                },
                                            }} />
                                    }
                                    label="เปิด EOC"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox 
                                            checked={eocunactive} 
                                            onChange={monitorSelectedChange} 
                                            name="eocunactive"
                                            sx={{
                                                color: 'rgba(0, 0, 0, 0.6)',
                                                '&.Mui-checked': {
                                                    color: 'rgb(212, 135, 108)',
                                                },
                                            }} />
                                    }
                                    label="ไม่เปิด EOC"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox 
                                            checked={eocqualify} 
                                            onChange={monitorSelectedChange} 
                                            name="eocqualify"
                                            sx={{
                                                color: 'rgba(0, 0, 0, 0.6)',
                                                '&.Mui-checked': {
                                                    color: 'rgb(212, 135, 108)',
                                                },
                                            }} />
                                    }
                                    label="เข้าเกณฑ์เปิด EOC"
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid> */}
                    {/* <Grid container item xl={6} justifyContent='right' lg={6} md={6} >
                        {
                            labelSummary.map((value, index) => {
                                return (
                                    <Grid key={index} item lg={4} xl={4} sx={{
                                        height: '34px',
                                        mt: '8px',
                                        pr: '10px'
                                    }}>
                                        <div style={{
                                            width: '100%',
                                            height: '100%',
                                            border: `solid 2px ${value.color}`,
                                            padding: '0px 5px',
                                            position: 'relative'
                                        }}>
                                            <Typography variant='span1' sx={{
                                                lineHeight: '30px',
                                                color: value.color
                                            }}>{value.label}</Typography>
                                            <Typography variant='span2' sx={{
                                                position: 'absolute',
                                                top: '4px',
                                                right: '10px',
                                                color: value.color
                                            }}>{valueSummary[value.attrValue]}</Typography>
                                        </div>
                                    </Grid>
                                )
                            })
                        }
                    </Grid> */}
                {/* </Grid> */}
                <TabPanel sx={{
                    padding: 0,
                    width: '100%',
                    height: '100%'
                }} value="map">
                    <MonitorMap eocqualify={monitorSelected.eocqualify} eocactive={monitorSelected.eocactive} eocunactive={monitorSelected.eocunactive}/>
                </TabPanel>
                <TabPanel className="w-full h-full pt-6 px-0 pb-0"value="table"><MonitorTable /></TabPanel>
                <TabPanel className="w-full h-full pt-6 px-0 pb-0" value="timeline"><MonitorTimeline /></TabPanel>
            </TabContext>
        </div>
    )
}

export default Monitor
